// extracted by mini-css-extract-plugin
export default {"a":"Anchor_a__6-3BF"};